import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Spin } from "antd";

const NoAuthGuard = ({ children }) => {
    const isLoggedIn = useSelector((state) => state.auth.isLogged);
    const loading = useSelector((state) => state.auth.loading);
    const navigate = useNavigate();


    useEffect(() => {
        if (loading && isLoggedIn) {
            navigate("/dashboard", { replace: true });
        }
    }, [isLoggedIn, loading, navigate]);

    if (loading) {
        return (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
                <Spin tip="Loading..." size="large" />
            </div>
        );
    }

    if (isLoggedIn) {
        return null;
    }

    return children;
};

export default NoAuthGuard;